import moment from 'moment'
import { createReducer, createNamespacer } from '../commons/js/utils/reducer';

const initialState = {
    packages: [],
    yearList: [],
    currentDate: moment().toDate(),
    currentYear: moment().year(),
    calendarView: "month",
    currentMonth: moment().month(),
    currentPackage: { key: 'All', id: 'All', label: 'All', value: 'All' },
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
}

const namespacers = {
    toolBar: createNamespacer("TOOLBAR"),
}

const toolBar = createReducer(initialState, {
    [namespacers.toolBar("SET_PACKAGES")]: (state, action) => {
        return {
            ...state,
            packages: [{ id: "All", packageID: "All" }, ...action.payload.packages]
        }
    },
    [namespacers.toolBar("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.toolBar("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.toolBar("SET_YEAR")]: (state, action) => {
        let year = []
        for (let i = moment().year() - 5; i <= moment().year() + 5; i++) {
            year.push(i);
        }
        return {
            ...state,
            yearList: year,
        }
    },
    [namespacers.toolBar("PREV_MONTH")]: (state, action) => {
        action.payload.value.date.setMonth(action.payload.value.date.getMonth() - 1);
        action.payload.value.onNavigate('prev');
        if (state.currentMonth <= 0) {
            return {
                ...state,
                currentMonth: 11,
                currentYear: Math.max(state.currentYear - 1, state.yearList[0]),
                currentDate: action.payload.value.date,
                currentPackage: action.payload.value.currentPackage,
            }
        }
        else {
            return {
                ...state,
                currentMonth: state.currentMonth - 1,
                currentDate: action.payload.value.date,
                currentPackage: action.payload.value.currentPackage,
            }
        }
    },
    [namespacers.toolBar("NEXT_MONTH")]: (state, action) => {
        action.payload.value.date.setMonth(action.payload.value.date.getMonth() + 1);
        action.payload.value.onNavigate('next');
        if (state.currentMonth >= 11) {
            return {
                ...state,
                currentMonth: 0,
                currentYear: Math.min(state.currentYear + 1, state.yearList[state.yearList.length - 1]),
                currentDate: action.payload.value.date,
                currentPackage: action.payload.value.currentPackage,
            }
        }
        else {
            return {
                ...state,
                currentMonth: state.currentMonth + 1,
                currentDate: action.payload.value.date,
                currentPackage: action.payload.value.currentPackage,
            }
        }
    },
    [namespacers.toolBar("SELECT_MONTH")]: (state, action) => {
        action.payload.value.date.setMonth(Number(action.payload.event));
        action.payload.value.onNavigate('Month Change');
        return {
            ...state,
            currentMonth: action.payload.event,
            currentDate: action.payload.value.date,
            currentPackage: action.payload.value.currentPackage,
        }
    },
    [namespacers.toolBar("SELECT_YEAR")]: (state, action) => {
        action.payload.value.date.setFullYear(Number(action.payload.event));
        action.payload.value.onNavigate('Year Change');
        return {
            ...state,
            currentYear: action.payload.event,
            currentDate: action.payload.value.date,
            currentPackage: action.payload.value.currentPackage,
        }
    },
    [namespacers.toolBar("SELECT_PACKAGE")]: (state, action) => {
        return {
            ...state,
            currentPackage: action.payload.value,
        }
    },
    [namespacers.toolBar("RESET_TOOLBAR")]: (state, action) => {
        return {
            ...state,
            // ...initialState
            currentDate: moment().toDate(),
            currentYear: moment().year(),
            currentMonth: moment().month(),
            currentPackage: initialState.currentPackage,
        }
    },
    [namespacers.toolBar("SET_DATE")]: (state, action) => {
        return {
            ...state,
            currentDate: moment(action.payload.date).toDate(),
            currentMonth: moment(action.payload.date).month(),
            currentYear: moment(action.payload.date).year(),
        }
    },
    [namespacers.toolBar("SET_CALENDAR_VIEW")]: (state, action) => {
        return {
            ...state,
            calendarView: action.payload.view
        }
    },
});

export default toolBar;
